import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, PieChartIcon, ClipboardListIcon, CalendarIcon, MessageSquareIcon, UserIcon, BellIcon, XIcon } from 'lucide-react';
interface VeliSidebarProps {
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (isOpen: boolean) => void;
}
const veliMenuItems = [{
  icon: HomeIcon,
  label: 'Anasayfa',
  path: '/'
}, {
  icon: PieChartIcon,
  label: 'Deneme Analizleri',
  path: '/deneme-analizleri'
}, {
  icon: ClipboardListIcon,
  label: 'Ödev Takibi',
  path: '/odev-takibi'
}, {
  icon: CalendarIcon,
  label: 'Ders Programı',
  path: '/ders-programi'
}, {
  icon: MessageSquareIcon,
  label: 'Mesajlarım',
  path: '/mesajlarim'
}, {
  icon: BellIcon,
  label: 'Bildirimler',
  path: '/bildirimler'
}, {
  icon: UserIcon,
  label: 'Profil',
  path: '/profil'
}];
export function VeliSidebar({
  isMobileMenuOpen,
  setIsMobileMenuOpen
}: VeliSidebarProps) {
  const location = useLocation();
  const handleLinkClick = () => {
    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(false);
    }
  };
  return <>
      {/* Desktop Sidebar - Unchanged */}
      <div className="hidden md:block relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-indigo-600 w-full md:w-64 md:min-w-[250px] shrink-0" data-id="element-1154">
        <aside className="sticky top-4 bg-black/90 rounded-xl p-4 w-full h-full" data-id="element-1155">
          {/* Logo Kısmı */}
          <div className="mb-6 text-center" data-id="element-1156">
            <h2 className="text-xl font-bold text-white" data-id="element-1157">EĞİTİM PİLOTU</h2>
            <p className="text-blue-400 text-sm" data-id="element-1158">Veli Paneli</p>
          </div>
          {/* Menü */}
          <nav className="space-y-2" data-id="element-1159">
            {veliMenuItems.map(item => <Link key={item.label} to={item.path} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${location.pathname === item.path ? 'text-white border border-blue-500 border-opacity-80 bg-blue-500/20' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-1160">
                <item.icon className="w-5 h-5 shrink-0" data-id="element-1161" />
                <span className="text-sm font-medium whitespace-nowrap" data-id="element-1162">
                  {item.label}
                </span>
              </Link>)}
          </nav>
        </aside>
      </div>
      {/* Mobile Sidebar Overlay */}
      {isMobileMenuOpen && <div className="md:hidden fixed inset-0 z-50" data-id="element-1163">
          {/* Backdrop Overlay */}
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setIsMobileMenuOpen(false)} data-id="element-1164"></div>
          {/* Sidebar Panel */}
          <div className="fixed inset-y-0 left-0 w-64 bg-black/95 shadow-lg transform transition-transform duration-300 ease-in-out p-[1px] rounded-r-xl overflow-hidden bg-gradient-to-r from-blue-600 to-indigo-600" data-id="element-1165">
            <div className="h-full bg-black/90 rounded-r-xl overflow-y-auto" data-id="element-1166">
              {/* Header with close button */}
              <div className="flex items-center justify-between p-4 border-b border-gray-800/50" data-id="element-1167">
                <div data-id="element-1168">
                  <h2 className="text-xl font-bold text-white" data-id="element-1169">
                    EĞİTİM PİLOTU
                  </h2>
                  <p className="text-blue-400 text-sm" data-id="element-1170">Veli Paneli</p>
                </div>
                <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 rounded-lg hover:bg-white/10 transition-colors" data-id="element-1171">
                  <XIcon className="w-5 h-5 text-gray-300" data-id="element-1172" />
                </button>
              </div>
              {/* Menu Items */}
              <nav className="p-4 space-y-2" data-id="element-1173">
                {veliMenuItems.map(item => <Link key={item.label} to={item.path} onClick={handleLinkClick} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${location.pathname === item.path ? 'text-white border border-blue-500 border-opacity-80 bg-blue-500/20' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-1174">
                    <item.icon className="w-5 h-5 shrink-0" data-id="element-1175" />
                    <span className="text-sm font-medium whitespace-nowrap" data-id="element-1176">
                      {item.label}
                    </span>
                  </Link>)}
              </nav>
            </div>
          </div>
        </div>}
    </>;
}